/**
 * Times New Roman regulatory typography per "Draft 1.0 Style Guide for Regulatory Documents"
 * (§4.1 C-Title/C-Heading 1-5/C-Body Text, §4.2 Caption/C-Table Header/C-Table Text,
 * §4.3 C-Footnote). Mirrors the protocol editor's FONT_CONFIG so other document types (SAP)
 * can adopt the same fonts/sizes without depending on DocumentEditor.jsx internals.
 */
export const REGULATORY_FONT_CONFIG = {
  title: { name: 'Times New Roman', size: 18, bold: true, color: '000000', lineSpacing: 1.15 },
  heading: { name: 'Times New Roman', size: 14, bold: true, color: '000000', lineSpacing: 1.15 },
  subheading: { name: 'Times New Roman', size: 12, bold: true, color: '000000', lineSpacing: 1.15 },
  heading3: { name: 'Times New Roman', size: 11, bold: true, color: '000000', lineSpacing: 1.15 },
  heading4: { name: 'Times New Roman', size: 11, bold: true, color: '000000', lineSpacing: 1.15 },
  body: { name: 'Times New Roman', size: 12, bold: false, color: '000000', lineSpacing: 1.15 },
  caption: { name: 'Times New Roman', size: 12, bold: true, color: '000000', lineSpacing: 1.15 },
  tableHeader: { name: 'Times New Roman', size: 11, bold: true, color: '000000', lineSpacing: 1.15 },
  tableCell: { name: 'Times New Roman', size: 11, bold: false, color: '000000', lineSpacing: 1.15 },
  footnote: { name: 'Times New Roman', size: 10, bold: false, color: '000000', lineSpacing: 1.15 },
};

/** docx.js TextRun `size` is in half-points. */
export function ptToHalfPoints(pt) {
  return Math.round(pt * 2);
}

/** Heading level 1-4 -> the matching FONT_CONFIG entry (falls back to heading4 beyond level 4). */
export function fontConfigForHeadingLevel(fontConfig, level) {
  const key = level === 1 ? 'heading' : level === 2 ? 'subheading' : level === 3 ? 'heading3' : 'heading4';
  return fontConfig[key] || fontConfig.heading;
}
